import { postRequest } from '@/core';
import { subOrders } from '@/requests';

export default async function getGeocodeSubOrdersRequest(ids) {
	let url = subOrders.getGeocodeOrdersPath();
	let response = await postRequest(url, {}, ids);
	return response;
}
